// extracted by mini-css-extract-plugin
module.exports = {"component":"LanguagePage_component__2LCe0","back":"LanguagePage_back__2VWUu","header":"LanguagePage_header__cW1XF","main":"LanguagePage_main__1GF-S"};